import * as actionType from "../Actions/Action_Type";

const initialState = {
    isFetching   : false,
    errorMessage : null,
    animation    : "flipInY",
    confirmed    : false
};

const confermaEmailReducer = (state = initialState, action) => {
    switch (action.type){
        case actionType.SERVICE_CONFIRM_EMAIL_REQUEST :
            return Object.assign({}, state, {
                isFetching    : true,
                errorMessage  : null,
                animation     : "",
                confirmed     : false
            })
        case actionType.SERVICE_CONFIRM_EMAIL_SUCCESS :
            return Object.assign({}, state, {
                isFetching    : false,
                animation     : "",
                confirmed     : true
            })
        case actionType.SERVICE_CONFIRM_EMAIL_ERROR :
            return Object.assign({}, state, {
                isFetching    : false,
                errorMessage  : action.error || null,
                animation     : "anim-shake",
                confirmed     : false
            })
        case actionType.SERVICE_CONFIRM_EMAIL_GOTOLOGIN :
            return Object.assign({}, state, {
                animation     : "flipOutY"
            })
        default:
            return state;
    }
};

export default confermaEmailReducer;


// WEBPACK FOOTER //
// ./src/Reducers/Reducer_ConfermaEmail.js